import { render } from "./PayBillPage.vue?vue&type=template&id=398c2936&ts=true"
import script from "./PayBillPage.vue?vue&type=script&lang=ts"
export * from "./PayBillPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__